import { ReactNode } from 'react';
import { useParams } from 'react-router-dom';

import { useFeatureFlag } from '@/hooks/useFeatureFlag';

import { NotFound } from '../NotFound';

interface FeatureFlagRouteProps {
  featureName: string;
  renderWhenOn?: ReactNode;
  renderWhenOff?: ReactNode;
  attributes?: { [key: string]: any };
}

export const FeatureFlagRoute = ({
  featureName,
  renderWhenOn,
  renderWhenOff,
  attributes = {},
}: FeatureFlagRouteProps) => {
  // Panel-scoped routes expose the panel id as `:id`, so flags on those routes
  // can be targeted per panel in Split. Explicit attributes win over it.
  const { id: panelId } = useParams<{ id?: string }>();
  const { isFlagOn, isFlagOff } = useFeatureFlag({
    name: featureName,
    attributes: panelId ? { panel_id: panelId, ...attributes } : attributes,
  });

  if (isFlagOn && renderWhenOn) {
    return <>{renderWhenOn}</>;
  }

  if (isFlagOff && renderWhenOff) {
    return <>{renderWhenOff}</>;
  }

  return <NotFound />;
};
